const ONLINE_CDN =process.env.ONLINE_CDN; //"http://c0.ifengimg.com/web/d/"
const Script_Conf = require("../../tmp/jsConfig");
function getScriptUrl(url,callback){
    let mUrl = url;
    if (url.substr(0, 4) != "http" && url.substr(0, 2)!="\/\/"){
        mUrl= ONLINE_CDN+url;
    }
    console.log(Script_Conf);
    if (Script_Conf.hasOwnProperty(callback)){
        let item = Script_Conf[callback];
        mUrl = `${item.dist}?key=${callback}&ver=${item.version}`;
    }
    return mUrl;
}
export default getScriptUrl;